// extracted by mini-css-extract-plugin
export default {"block":"input_block__SGNgv","label":"input_label__nfHFy","input":"input_input__ETrTc"};